"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _permission = require("@/utils/permission");
var _merUseCategory = _interopRequireDefault(require("@/components/merUseCategory"));
var _public = require("@/libs/public");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'SeckillList',
  components: {
    merchantName: _merUseCategory.default
  },
  data: function data() {
    return {
      orderImg: require('@/assets/imgs/order_icon.png'),
      isShow: 0,
      //1审核，2查看，3编辑
      loading: false,
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      proName: '',
      activityName: '',
      tableFrom: {
        page: 1,
        limit: 20,
        proName: '',
        activityName: '',
        merStars: null,
        auditStatus: '2',
        merIds: '',
        activityStatus: '',
        proStatus: ''
      },
      headeNum: [{
        name: '审核成功',
        type: '2'
      }, {
        name: '待审核',
        type: '1'
      }, {
        name: '审核失败',
        type: '3'
      }],
      multipleSelection: [],
      ruleForm: {
        reason: '',
        auditStatus: 'success',
        id: ''
      },
      rules: {
        auditStatus: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }],
        reason: [{
          required: true,
          message: '请填写拒绝原因',
          trigger: 'blur'
        }]
      },
      dialogVisible: false,
      loadingBtn: false,
      id: '',
      //秒杀商品id
      merIds: [],
      //商户id
      seckillInfo: {}
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:user:tag:list'])) this.getList(1);
    if (!localStorage.getItem('merPlatProductClassify')) this.$store.dispatch('product/getAdminProductClassify');
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handleAudit: function handleAudit(row, n) {
      this.id = row.id;
      this.isShow = n;
      this.dialogVisible = true;
      this.seckillInfo = row;
    },
    close: function close(refName) {
      this.dialogVisible = false;
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    reset: function reset(formName) {
      this.proName = '';
      this.activityName = '';
      this.merIds = [];
      this.tableFrom.proName = '';
      this.tableFrom.activityName = '';
      this.tableFrom.merStars = null;
      this.tableFrom.merIds = null;
      this.tableFrom.proName = '';
      this.tableFrom.activityStatus = '';
      this.tableFrom.proStatus = '';
      this.getList(1);
    },
    //审核拒绝
    cancelForm: function cancelForm() {
      var _this = this;
      this.$modalPrompt('textarea', '拒绝原因').then(function (V) {
        _this.ruleForm.reason = V;
        _this.submit();
      });
    },
    // 审核提交
    onSubmit: function onSubmit(type) {
      var _this2 = this;
      this.ruleForm.auditStatus = type;
      if (type === 'success') {
        this.$modalSure('审核通过该秒杀商品吗？').then(function () {
          _this2.submit();
        });
      } else {
        this.cancelForm();
      }
    },
    submit: function submit() {
      var _this3 = this;
      this.loadingBtn = true;
      this.ruleForm.id = this.id;
      (0, _marketing.seckillProAuditApi)(this.ruleForm).then(function (res) {
        _this3.$message.success('操作成功');
        _this3.dialogVisible = false;
        _this3.loadingBtn = false;
        _this3.getList();
      }).catch(function (res) {
        _this3.loadingBtn = false;
      });
    },
    //表格选中
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getMerId: function getMerId(id) {
      this.merIds = id;
      this.tableFrom.merIds = id.toString();
      this.getList();
    },
    // 列表
    getList: function getList(num) {
      var _this4 = this;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.activityName = encodeURIComponent(this.activityName);
      this.tableFrom.proName = encodeURIComponent(this.proName);
      this.listLoading = true;
      (0, _marketing.seckillProListApi)(this.tableFrom).then(function (res) {
        _this4.tableData.data = res.list;
        _this4.tableData.total = res.total;
        _this4.listLoading = false;
      }).catch(function (res) {
        _this4.listLoading = false;
      });
    },
    //批量删除
    batchDel: function batchDel() {
      var _this5 = this;
      var ids = this.multipleSelection.map(function (item) {
        return item.id;
      }).toString();
      this.$modalSure('批量删除秒杀商品吗？').then(function () {
        (0, _marketing.seckillProDelApi)({
          ids: ids
        }).then(function () {
          _this5.$message.success('删除成功');
          _this5.getList();
        });
      });
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this6 = this;
      this.$modalSure('删除该秒杀商品吗？').then(function () {
        (0, _marketing.seckillProDelApi)({
          ids: row.id
        }).then(function () {
          _this6.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this6.tableData.data.length, _this6.tableFrom);
          _this6.getList();
        });
      });
    },
    //批量下架
    batchDown: function batchDown() {
      var _this7 = this;
      var ids = this.multipleSelection.map(function (item) {
        return item.id;
      }).toString();
      this.$modalSure('批量下架秒杀商品吗？').then(function () {
        (0, _marketing.seckillProDownApi)({
          ids: ids
        }).then(function () {
          _this7.$message.success('下架成功');
          _this7.getList();
        });
      });
    },
    //下架
    handleDown: function handleDown(row) {
      var _this8 = this;
      this.$modalSure('下架该秒杀商品吗？').then(function () {
        (0, _marketing.seckillProDownApi)({
          ids: row.id
        }).then(function () {
          _this8.$message.success('下架成功');
          _this8.getList();
        });
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    //编辑价格
    setPrice: function setPrice(id, row) {
      var _this9 = this;
      var productList = {
        productList: [{
          attrValue: row.map(function (item) {
            return {
              activityPrice: item.price,
              id: item.id
            };
          }),
          id: id
        }]
      };
      (0, _marketing.seckillProSetPriceApi)(productList).then(function (res) {
        _this9.$message.success('保存成功');
        _this9.getList();
        _this9.dialogVisible = false;
      }).catch(function (res) {});
    }
  }
};